import { Avatar, AvatarProps } from '@thoughtspot/radiant-react/widgets/avatar';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import {
    Colors,
    Typography,
} from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import * as React from 'react';
import styles from './editable-list.module.scss';

export interface Item {
    label: string;
    className?: string;
    errorMessage?: string;
    isDisabled?: boolean;
    avatar?: AvatarProps;
}

export interface EditableListProps {
    items: Item[];
    className?: string;
    onRemove?: (label: string) => void;
}

export const EditableList: React.FC<EditableListProps> = ({
    items,
    className,
    onRemove,
}) => {
    return (
        <div className={styles.listItemContainer}>
            <ul
                data-testid="editable-list"
                className={cx(className, styles.listContainer)}
            >
                {items.map((item: Item, index: number) => (
                    <li
                        key={item.avatar.name}
                        className={cx(item.className, styles.itemContainer)}
                    >
                        <Horizontal grow className={styles.listItem}>
                            {item.avatar && (
                                <Avatar
                                    size="s"
                                    showName
                                    name={item.avatar.name}
                                    src={item.avatar.src}
                                    disabled={item.isDisabled}
                                />
                            )}
                            <Button
                                icon={IconID.CROSS}
                                size="s"
                                type="secondary"
                                onClick={() => onRemove(item.label)}
                                className={styles.itemRemoveIcon}
                            />
                        </Horizontal>
                        {item.errorMessage && (
                            <Typography
                                variant="p-small"
                                color={Colors.failure}
                                className={styles.errorMessage}
                            >
                                {item.errorMessage}
                            </Typography>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};
